import { render, staticRenderFns } from "./ModalOsVencidas.vue?vue&type=template&id=7a09221c&scoped=true&"
import script from "./ModalOsVencidas.vue?vue&type=script&lang=js&"
export * from "./ModalOsVencidas.vue?vue&type=script&lang=js&"
import style0 from "./ModalOsVencidas.vue?vue&type=style&index=0&id=7a09221c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a09221c",
  null
  
)

export default component.exports